import { useRef } from "react";
import Icon from "../../../components/atoms/Icon";
import SplitLayout from "../../../components/atoms/SplitLayout";
import OperatorInterface from "../../../interfaces/OperatorInterface";
import { AnnounceDestinationTagWithFormStateInterface } from "../../../interfaces/SectionAnnounceMessagesStateInterface";
import SectionInterface from "../../../interfaces/SectionInterface";
import AnnounceMessageForm from "../AnnounceMessageForm";
import AnnounceMessageList from "./AnnounceMessageList";
import styles from "./styles.scss";
import { TagName } from "./TagName";

interface Props {
  destinationTag: AnnounceDestinationTagWithFormStateInterface | null;
  onCloseRightColumn: () => void;
  section: SectionInterface;
  isDestinationTagModalOpen: boolean;
  onOpenDestinationTagModal: () => void;
  onCloseDestinationTagModal: () => void;
  currentOperator: OperatorInterface;
}

const AnnounceMessage: React.FC<Props> = (props) => {
  const splitLayoutRef = useRef<HTMLDivElement>(null);
  return (
    <div className={styles.root} ref={splitLayoutRef}>
      <SplitLayout.Header>
        <Icon
          name="icon-arrow-close"
          className={styles.close}
          onClick={props.onCloseRightColumn}
        />
        <span className={styles.header}>
          <TagName section={props.section} tag={props.destinationTag} />
        </span>
      </SplitLayout.Header>
      <SplitLayout.Body>
        {props.destinationTag ? (
          <AnnounceMessageList
            destinationTag={props.destinationTag}
            section={props.section}
          />
        ) : (
          <div className={styles.listContainer} />
        )}
        <AnnounceMessageForm
          destinationTag={props.destinationTag}
          section={props.section}
          isDestinationTagModalOpen={props.isDestinationTagModalOpen}
          onOpenDestinationTagModal={props.onOpenDestinationTagModal}
          onCloseDestinationTagModal={props.onCloseDestinationTagModal}
          currentOperator={props.currentOperator}
          textareaMaxHeightBaseElementRef={splitLayoutRef}
        />
      </SplitLayout.Body>
    </div>
  );
};

export default AnnounceMessage;
